import * as React from 'react'

import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'

import ImportModal from 'modules/employees/pages/ImportContractsPage/components/ImportModal'

import type { ImportedContract } from './Content/types'
import TableTabs from './TableTabs'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ImportedContract>

interface Props {
  contracts: ImportedContract[]
  selected: ImportedContract[]
  attributes: string[]
  customFields: string[]
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
}

const ImportTable = ({
  contracts,
  selected,
  attributes,
  customFields,
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
}: Props) => {
  const [isModalOpen, toggleModal] = React.useState(false)

  return (
    <>
      {isModalOpen && (
        <ImportModal selectedContracts={selected} onClose={() => toggleModal(false)} />
      )}
      <TableTabs
        contracts={contracts}
        selected={selected}
        attributes={attributes}
        customFields={customFields}
        onToggleSelectedItem={onToggleSelectedItem}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
        toggleModal={() => toggleModal(true)}
      />
    </>
  )
}

export default ImportTable
